import { render, staticRenderFns } from "./IconPhoneAlt.vue?vue&type=template&id=7c34c3b6&"
import script from "./IconPhoneAlt.vue?vue&type=script&lang=js&"
export * from "./IconPhoneAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports